export function SET_PRODUCTS(state, products) {
  state.productsInProject = products;
}

export function SET_PROJECT_TO_UPDATED(state, project) {
  state.projectToUpdate = project;
}
